<div class="bpaas-not-found">
  <div class="card">
    <div class="flex flex-column align-items-center justify-content-center card-container h-screen">
        <div class="bpaas-exception-title mb-3">NOT FOUND</div>
        <div class="bpaas-exception-detail mb-7">Requested resource is not available.</div>
        <div class="bpaas-exception-detail mb-3">
          <button pButton pRipple btnback type="button">Back to Dashborad</button>
        </div>
    </div>
  </div>
</div>
